<template>
  <div class="layout participant-container">
    <div class="flex layout participant-list">
      <div v-for="(participant,index) in value" :key="index" class="layout">
        <div class="participant">
          <div @click="change(participant)" class="participant-icon circle">
            <span @click.stop="remove(participant)" v-if="participant.removable"
                  class="participant-remove el-icon-error"></span>
            <span>{{participant.name[0]}}</span>
          </div>
          <div class="participant-desc">{{participant.name}}</div>
        </div>
        <div class="activate"
             :class="'icon-'+{'notify':'plus','and':'plus','or':'oblique','one_by_one':'arrow-right'}[options.activate]"></div>
      </div>
    </div>
    <div v-if="addable" :class="value.length?'':'required'" @click="add" class="participant-add circle icon-plus"></div>
  </div>
</template>

<script>
  import {JsonService,Message} from "@maidi/common";
  import orgApi from "@/apis/org";
  import CacheService from "@/service/catch";
  import {Selector} from "@/service/selector";
  import {ApproveType, SelectRange} from "../workflow/process/process";

  export default {
    name: "participant",
    props: {
      options: {},
      value: {
        type: Array,
        default() {
          return [];
        }
      }
    },
    data() {
      return {};
    },
    methods: {
      remove(participant) {
        const participants = JsonService.clone(this.value);
        const index = participants.findIndex(item => item.id === participant.id);
        if (~index) {
          participants.splice(index, 1);
        }
        this.$emit("input", participants);
      },
      async add() {
        let participants = [];
        let selected = JsonService.clone(this.value.filter(_item => _item.removable));
        selected.forEach(item => delete item.removable);
        if (!this.options.multi) {
          selected = selected[0];
        }
        if (this.options.select === SelectRange.Range) {
          const selector = await Selector.Model();
          selector.options(this.options.range).fields("id", "name").multi(this.options.multi).icon(`<span class="item-text-icon"><span>{{model.text[0]}}</span></span>`);
          participants = await selector.show(selected);
          !this.options.multi && (participants = participants && [participants] || []);
        }
        else {
          participants = await Selector.OrgShow(selected,this.options.multi);
          participants = participants.map(participant => {
            return {id: participant.id, name: participant.name};
          });
        }
        const value = this.value.filter(_item => !_item.removable);
        value.push(...participants.map(item => {
          return {
            removable: true,
            id: item.id,
            name: item.name
          };
        }).filter(item => !value.some(participant => participant.id === item.id)));
        this.$emit("input", value);
      },
      change(participant) {
        if (participant.removable && !this.options.multi) {
          this.add();
        }
      }
    },
    mounted() {
      const values = this.value.filter(_item =>!(this.options.range&&this.options.range.some(__item=>_item.id===__item.id))).map(item=>({
        removable: true,
        id: item.id,
        name: item.name
      }));
      if (this.options.type === ApproveType.Range || this.options.type === ApproveType.RangeAndSelect) {
        this.$emit("input", [...this.options.range,...values]);
      }
      else if (this.options.type === ApproveType.Select && this.options.select === SelectRange.Range && this.options.range.length === 1) {
        //申请人自选，且选择范围只有一个人时
        this.$emit("input", [...this.options.range,...values]);
      } else if (this.options.type === ApproveType.Director) {
        const user =CacheService.get("user");
        orgApi.getLeaderList(user.departmentId).then(res=>{
            const leader=res[0]||[]
            if (!leader) {
              const error = "用户所在的部门主管不存在";
              return Message.error(error);
            }
          this.$emit("input", [{id: leader.id, name: leader.realName}]);
        })
      }
      else if (this.options.type === ApproveType.Originator) {
        const user = CacheService.get('user');
        this.$emit("input", [{id: user.userID, name: user.realName}]);
      }
    },
    computed: {
      addable() {
        if (this.options.type !== ApproveType.RangeAndSelect && this.options.type !== ApproveType.Select) {
          return false;
        }
        return this.options.multi || this.value.length === 0;
      }

    }
  }
</script>

<style scoped lang="scss">
  @import "../../../assets/css/global";

  .participant-container {
    align-self: flex-start;
    padding-top: 12px;
  }

  .participant-list {
    justify-content: flex-end;
    flex-wrap: wrap;
    &:last-child {
      > *:last-child {
        .activate {
          display: none;
        }
      }
    }
  }

  .circle {
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    text-align: center;
  }

  .participant {
    text-align: center;
    margin-bottom: 10px;
    .participant-remove {
      position: absolute;
      right: -5px;
      top: -5px;
      font-size: 1.6rem;
      border-radius: 50%;
      color: $color-error;
      line-height: 1.2;
    }

    .participant-icon {
      position: relative;
      margin: 0 auto;
      background-color: $color-primary;
      color: $color-bg;
      cursor: pointer;
      font-size: 1.3rem;
      padding: 0 5px;
    }

    .participant-desc {
      color: $color-font-light;
      font-size: 1.2rem;
    }
  }

  .activate {
    color: $color-font-light;
    padding: 0 10px;
    height: 40px;
    line-height: 40px;
  }

  .participant-add {
    border: 1px dashed $color-primary;
    color: $color-primary;
    cursor: pointer;
    font-size: 2rem;
    position: relative;
    &.required:after {
      content: "*";
      position: absolute;
      color: $color-error;
      line-height: 1;
      right: 0
    }
  }
</style>
